export default "__VITE_ASSET__BN4y8dV1__"